<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';

let globalId = 0;
export default defineComponent({
  name: 'OIconImgError',
  svgType: 'fill',
  setup() {
    const classNames = ['o-svg-icon', 'o-icon-img-error', 'type-fill'];
    const isClient = ref(false);
    onMounted(() => {
      isClient.value = true;
    });
    return {
      isClient,
      classNames,
      globalId: globalId++,
    };
  },
});
</script>
<template>
  <svg viewBox="0 0 24 24" :class="classNames">
    <template v-if="isClient">
      <path fill-rule="evenodd" d="M21.74 5.5a1.95 1.95 0 0 0-1.94-1.75H4.2l-.2.01c-.983.1-1.75.93-1.75 1.94v12.6l.01.2c.1.983.93 1.75 1.94 1.75h15.6l.2-.01a1.95 1.95 0 0 0 1.75-1.94v-7.952l-.002-.018a1 1 0 0 0-.008-.098l-.002-.018a.75.75 0 0 0-1.293-.372l-4.883 5.345-4.657-3.71-.114-.074a.75.75 0 0 0-.864.112l-5.079 4.727-.09.1a.75.75 0 0 0 .052.96l.101.09a.75.75 0 0 0 .96-.052l4.605-4.287 4.7 3.745.122.08a.75.75 0 0 0 .9-.16l4.052-4.438v6.02l-.012.103a.45.45 0 0 1-.438.347H4.2l-.103-.012a.45.45 0 0 1-.347-.438V5.7l.012-.103A.45.45 0 0 1 4.2 5.25h15.6l.103.012a.45.45 0 0 1 .347.438v1.467l.012.135a.75.75 0 0 0 1.488-.135V5.7zM4.89 8.668a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0m3 0a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0"/>
    </template>
  </svg>
</template>